/* src/app/invoice/management/invoice-cycle/invoice-cycle.component.scss */
body#themeTag :host ::ng-deep .p-datatable-table .p-datatable-tbody > tr {
  height: 25px;
}
body#themeTag :host ::ng-deep .p-datatable-table .p-datatable-tbody > tr > td.p-datatable-cell {
  height: 25px;
}
body#themeTag :host ::ng-deep .p-datatable-scrollable-body {
  margin-top: 0.8em;
}
body#themeTag :host ::ng-deep .p-multiselect.p-component {
  height: 2.1em !important;
}
/*# sourceMappingURL=invoice-cycle.component.css.map */
